module.exports = __webpack_public_path__ + "static/Certificate-3befce16d6f2768681c78c3da2cfbc7c.png";